// extracted by mini-css-extract-plugin
export default {"wrapper":"Card_wrapper__9eTvN","iconWrapper":"Card_iconWrapper__eWhD1","title":"Card_title__GABaT","description":"Card_description__fWptn"};